import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]";
import { type SocietyProfileEducationInstanceOutputSum } from "shared/api/types/society/[societyId]/profiles/[profileId]/education";
import { type EducationInstanceView } from "shared/mappers/database/education/education-instance";
export const getSocietyProfileEducationInstanceContract: BaseApiContract<
  SocietyProfileParamsInput,
  undefined,
  PaginatedResults<
    EducationInstanceView,
    SocietyProfileEducationInstanceOutputSum
  >
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/education/instance",
  paramsType: {} as SocietyProfileParamsInput,
  responseType: {} as PaginatedResults<
    EducationInstanceView,
    SocietyProfileEducationInstanceOutputSum
  >,
};
